<template>
    <div class="routes">
        <router-link to="/">Home</router-link> |
        <router-link to="/signup">SignUp</router-link> |
        <router-link to="/booking">Booking</router-link> |
        <router-link to="/access">Access</router-link> |
        <router-link to="/admin">Admin</router-link> 
      </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class DevHeaderRoues extends Vue {

}
</script>